import { runSearch } from './state/run-search.epic';

export const searchEpics = [runSearch];
